import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CompaniesComponent } from './modules/companies/companies.component';
import { LicensesComponent } from './modules/licenses/licenses.component';
import { LoginComponent } from './modules/login/login.component';
import { CompanyClient, LoginClient } from './client-provider/client';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ClientModule } from './client.module';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TableModule } from 'primeng/table';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from '@angular/router';
import { AuthService } from './client-provider/auth.service';
import { AuthGuard } from './client-provider/auth.guard';
import { ClientInterceptor } from './client-provider/auth.interceptor';
import {DialogModule} from 'primeng/dialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import {ToastModule} from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ModulesComponent } from './modules/modules/modules.component';
import { TreeTableCellEditor } from 'primeng/treetable';

@NgModule({
  declarations: [
    AppComponent,
    //CompaniesComponent,
    //LicensesComponent,
    LoginComponent,
  ],
  imports: [
    RouterModule,
    BrowserModule,
    AppRoutingModule,
    ClientModule,
    HttpClientModule,
    FormsModule,
    TableModule,
    InputTextModule,
    CalendarModule,
		DropdownModule,
		ButtonModule,
    InputTextModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    DialogModule,
    ToastModule,
  ],
  providers: [
    AuthService,
    AuthGuard,
    LoginClient,
    ConfirmationService,
    MessageService,
    [      
    {      
      provide: HTTP_INTERCEPTORS,
      useClass: ClientInterceptor,
      multi: true,
    }
    ]
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
